export default [
  {
    description: 'Exportar Arquivo de Identificação de Estudantes',
    path: '/censoescolar/manutencao',
    name: 'censo_exportar_dados',
    component: () => import('@/views/censoescolar/manutencao/ExportarArquivoIdentificacao.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Importar Arquivo de Atualização do Código INEP',
    path: '/censoescolar/manutencao',
    name: 'censo_importar_dados',
    component: () => import('@/views/censoescolar/manutencao/ImportarDadosINEP.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Monitoramento de Pendências',
    path: '/censoescolar/manutencao',
    name: 'censo_monitoramento',
    component: () => import('@/views/censoescolar/manutencao/Monitoramento.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
]

